export const COURSE_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  UNKNOWN: 'Unknown',
} as const;

export type CourseStatus =
  (typeof COURSE_STATUSES)[keyof typeof COURSE_STATUSES];
